import { render, staticRenderFns } from "./Activitydetail.vue?vue&type=template&id=b4625d8a&scoped=true&"
import script from "./Activitydetail.vue?vue&type=script&lang=js&"
export * from "./Activitydetail.vue?vue&type=script&lang=js&"
import style0 from "./Activitydetail.vue?vue&type=style&index=0&id=b4625d8a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b4625d8a",
  null
  
)

export default component.exports